/** @format */

import { post, download, showImg } from '@root/utils/httpWrap';

/**
 * 查看图片
 */
export const downLoadImg = (params: any): any => {
  return showImg(`/bangdao/saasapi/v1/image/view?fileName=${params.fileName}`, {});
};
/**
 * 在场车辆查询
 */
export const queryOrderEnterList = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderEnter/list', params);
};
/**
 * 在场车辆导出
 * @param params
 */
export const exportOrderEnter = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/orderEnter/export', params, fileName);
};

/**
 * 在场车辆详情
 */
export const queryOrderEnterDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderEnter/detail', params);
};

/**
 * 停车记录
 */
export const queryParkingRecordList = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderEnex/list', params);
};

/**
 * 停车记录导出
 * @param params
 */
export const exportOrderEnex = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/orderEnex/export', params, fileName);
};

/**
 * 停车记录详情
 */
export const queryParkingRecordDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderEnex/detail', params);
};

/**
 * 修正
 */

export const submitOrderEnterEdit = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderEnter/edit', params);
};

/**
 * 交易记录列表
 */
export const queryOrderPayList = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderPay/list', params);
};

/**
 * 交易记录导出
 * @param params
 */
export const exportOrderPay = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/orderPay/export', params, fileName);
};
/**
 * 交易记录详情
 */
export const queryOrderPayDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderPay/detail', params);
};

/**
 * 钞箱记录列表
 */
export const queryOrderChangeList = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderChange/list', params);
};

/**
 * 交易记录导出
 * @param params
 */
export const exportOrderChange = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/orderChange/export', params, fileName);
};

/**
 * 订单优惠记录
 */
export const discountSummaryRecord = (params: any): any => {
  return post('/bangdao/saasapi/v1/couponRecordLog/discountSummaryRecord', params);
};
/**
 * 订单汇总记录导出
 * @param params
 */
export const exportDiscountSummaryRecord = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/couponRecordLog/exportDiscountSummaryRecord', params);
};

// /**
//  * 企业成员查询设备分类列表
//  *
//  * @param {QueryConditionLogic} params
//  * @returns {AxiosPromise<ListResponse<IDeviceCategory>>}
//  */
// export const test = (params: any): AxiosPromise<ListResponse<any>> => {
//   return http.post(`ScanPay/monthRenew/login`, params)
// }
